










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import { JinroRoomDocument } from "@/services/datatypes";
import { JinroRoomStatus } from "@/services/jinro-room-status";
import { DEFAULT_BILLBOARD_CONTENT } from "../../services/constants";

@Component
export default class CreateNewJinroRoom extends Vue {
  title = "";
  @Prop() readonly refCollection!: firebase.firestore.CollectionReference;
  get isFormBlank(): boolean {
    return this.title === "";
  }

  async handleCreate() {
    const roomParams: JinroRoomDocument = {
      owner: this.$store.state.firebaseUser.uid,
      ownerName: this.$store.state.user.displayName,
      billboardContent: DEFAULT_BILLBOARD_CONTENT,
      currentJinroGameId: null,
      isDeleted: false,
      title: this.title,
      jinroRoomStatus: JinroRoomStatus.CreatingJinroRoom,
      timeCreated: firestore.FieldValue.serverTimestamp()
    };
    const doc = await this.refCollection.add({
      ...roomParams
    });
    this.title = "";
    this.$emit("created", doc.id);
  }
}
